import AppConstants from '@/constants/app.constants'
// Handle filter mstMenu by type
export const buildMenuList = (mstMenu) => {
  let menuMaster = []
  let menuMapping = []
  let menuWork = []
  let menuSetting = []
  let listMenu = []
  for (let key in mstMenu) {
    if (key.search('Master') !== -1) { // Check exists Master
      menuMaster.push(mstMenu[key])
    } else if (key.search('Mapping') !== -1) { // Check exists Mapping
      menuMapping.push(mstMenu[key])
    } else if (key.indexOf('BatchControl') !== -1 ||
                key.indexOf('TaskHistory') !== -1 ||
                key.indexOf('TaskStatement') !== -1) { // Check exists BatchControl, TaskHistory, TaskStatement
      menuWork.push(mstMenu[key])
    } else if (key.search('Setting') !== -1) { // Check exists Setting
      menuSetting.push(mstMenu[key])
    } else {
      continue
    }
  }
  listMenu.push({'Master': menuMaster}, {'Mapping': menuMapping}, {'Work': menuWork}, {'Setting': menuSetting})
  return listMenu
}

export const appSelectedInfo = (workMode) => {
  let app = {routeName: 'Dashboard', nameApp: 't-Sort仕分け', icon: 'icon_robot.svg'}
  switch (workMode) {
    case AppConstants.WORK_MODE_T_SORT:
      app = {routeName: 'Dashboard', nameApp: 't-Sort仕分け', icon: 'icon_robot.svg'} // app t-sort
      break
    case AppConstants.WORK_MODE_RO_BO_HI:
      app = {routeName: 'RoboHiDashboard', nameApp: 'CarriRo搬送', icon: 'robo-hi.png'} // app Robo-HI
      break
    default:
      app = {routeName: 'Dashboard', nameApp: 't-Sort仕分け', icon: 'icon_robot.svg'} // app t-sort
  }
  return app
}



// WEBPACK FOOTER //
// ./src/common/filter-menu.js